module.exports = __webpack_public_path__ + "img/quanjai.a91a5bfa.png";